<template>
<div class="traffic-map preload">
	<h4 v-html="title"></h4>
	<div class="traffic-map__header">
		<div class="traffic-map__header-cell"></div>
		<div v-for="(hours, key) in data" class="traffic-map__header-cell" v-html="_translate('m.heatmap.day.' + key)"></div>
	</div>
	<div class="traffic-map__table" data-min="112805" data-max="1742663">
		<!-- Axis -->
		<div class="traffic-map__day">
			<div class="traffic-map__tick"><span  v-html="_translate('m.heatmap.day.scale.top')"></span></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"><span v-html="_translate('m.heatmap.day.noon')"></span></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"></div>
			<div class="traffic-map__tick"><span v-html="_translate('m.heatmap.day.scale.bottom')"></span></div>
		</div>

		<div v-for="(hours, key) in data" class="traffic-map__day grow">
			<div v-for="(sessions, hour) in orderHours(hours)" class="traffic-map__cell" :style="getCellOpacity(sessions)">&nbsp;</div>
		</div>

	</div>
	<div class="traffic-map__legend">
		<div class="traffic-map__legend-gradient"></div>
		<div class="traffic-map__legend-text">
			<span class="left">{{ thousandSeparators(Math.floor(getMinSessions/1000)*1000) }} <span class="sessions" v-html="_translate('m.heatmap.label')"></span></span>
			<span class="right">{{ thousandSeparators(Math.ceil(getMaxSessions/10000)*10000) }} <span class="sessions" v-html="_translate('m.heatmap.label')"></span></span>
		</div>
	</div>
</div>
</template>

<script>

	export default {

		props: {
			title: {
				type: String,
				default: 'Heat Map',
			},
			data: {
				type: Object,
				default: () => {}
			},
			max: {
				type: Number,
				default: 100,
			}
		},

		computed: {

			getMaxSessions: function() {

				var max = 0,
				    sessions = 0;

				for ( var key in this.data ) {
					for ( var sessionKey in this.data[key] ) {
						sessions = Number(this.data[key][sessionKey]);
						if ( sessions > max ) {
							max = sessions;
						}
					}
				}

				return max;

			},

			getMinSessions: function() {

				var min = this.getMaxSessions,
					  sessions = 0;

				for ( var key in this.data ) {
					for ( var sessionKey in this.data[key] ) {
						sessions = Number(this.data[key][sessionKey]);
						if ( sessions < min ) {
							min = sessions;
						}
					}
				}

				return min;

			}

		},

		methods: {

			getCellOpacity: function(sessions) {

				var max = this.getMaxSessions,
				    percentage = sessions / max;

				return 'opacity: ' + percentage;

			},

			orderHours: function(hours) {

				var keys = Object.keys(hours),
				    newHours = {};

				keys = keys.reverse();

				for ( var key of keys ) {
					newHours[key] = hours[key];
				}

				return newHours;

			}

		}

	}

</script>

<style lang="scss">

	.traffic-map {
		padding: 2rem 0rem;

		@include mq(phab) {
			padding: 2rem 1rem;
		}

		@include mq(pad) {
			padding: 2rem;
		}

		&.preload {
			// opacity: 0;
		}

		&.js-grow {

			.traffic-map__day.grow {
				transform: scaleY(1);
				transition: transform .7s ease .4s;

				&:nth-of-type(3){transition-delay: .45s;}
				&:nth-of-type(4){transition-delay: .5s;}
				&:nth-of-type(5){transition-delay: .55s;}
				&:nth-of-type(6){transition-delay: .6s;}
				&:nth-of-type(7){transition-delay: .65s;}
				&:nth-of-type(8){transition-delay: .7s;}

			}

		}

		h4 {
			font-size: 1.4rem;
	    line-height: 1.4em;
	    color: #D0191D;
	    font-weight: 600;
	    margin-bottom: 1.5rem;
	    text-align: center;
	    margin-top: 0;
		}
	}

	$traffic-grid: 4rem 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
	$traffic-grid--mob: 3rem 1fr 1fr 1fr 1fr 1fr 1fr 1fr;

	.traffic-map__header {
		display: grid;
		grid-template-columns: $traffic-grid--mob;
		grid-column-gap: 1px;

		@include mq(tab) {
			grid-template-columns: $traffic-grid;
		}
	}

	.traffic-map__header-cell {
		font-size: .8rem;
		text-transform: uppercase;
		padding: .5rem;
		color: $grey;
		letter-spacing: .1em;
		text-align: center;

		@include mq(tabdown) {
			font-size: 0;
			&:first-letter {
				font-size: .6rem;
				font-weight: 400;
			}
		}

	}

	.traffic-map__table {
		height: 200px;
		max-height: 200px;
		display: grid;
		grid-template-columns: $traffic-grid--mob;
		grid-column-gap: 1px;

		@include mq(phab) {
			height: 260px;
			max-height: 260px;
		}

		@include mq(pad) {
			height: 320px;
			max-height: 320px;
		}

		@include mq(tab) {

			height: 400px;
			max-height: 400px;
			grid-template-columns: $traffic-grid;

		}

	}

	.traffic-map__table,
	.traffic-map__header {
		@include mq('ms') {
			> div {
				-ms-grid-row: 1;
			}
			> :nth-child(1) {
				-ms-grid-column: 1;
			}
			> :nth-child(2) {
				-ms-grid-column: 2;
			}
			> :nth-child(3) {
				-ms-grid-column: 3;
			}
			> :nth-child(4) {
				-ms-grid-column: 4;
			}
			> :nth-child(5) {
				-ms-grid-column: 5;
			}
			> :nth-child(6) {
				-ms-grid-column: 6;
			}
			> :nth-child(7) {
				-ms-grid-column: 7;
			}
			> :nth-child(8) {
				-ms-grid-column: 8;
			}
		}
	}

	.traffic-map__day {
		display: grid;
		grid-template-rows: repeat(24, 1fr);
		height: 100%;
		transition: height .7s ease;

		@include mq('ms') {

			&.grow {
				overflow: hidden;
				> div {
					width: 999px;
					max-width: 100%;
					height: 11px;

					@include mq('tab') {
						height: 17px;
					}
				}
			}

			> div {
				// border: 1px dashed $red;
				-ms-grid-column: 1;
			}
			:nth-child(1) {
				-ms-grid-row: 1;
			}
			:nth-child(2) {
				-ms-grid-row: 2;
			}
			:nth-child(3) {
				-ms-grid-row: 3;
			}
			:nth-child(4) {
				-ms-grid-row: 4;
			}
			:nth-child(5) {
				-ms-grid-row: 5;
			}
			:nth-child(6) {
				-ms-grid-row: 6;
			}
			:nth-child(7) {
				-ms-grid-row: 7;
			}
			:nth-child(8) {
				-ms-grid-row: 8;
			}
			:nth-child(9) {
				-ms-grid-row: 9;
			}
			:nth-child(10) {
				-ms-grid-row: 10;
			}
			:nth-child(11) {
				-ms-grid-row: 11;
			}
			:nth-child(12) {
				-ms-grid-row: 12;
			}
			:nth-child(13) {
				-ms-grid-row: 13;
			}
			:nth-child(14) {
				-ms-grid-row: 14;
			}
			:nth-child(15) {
				-ms-grid-row: 15;
			}
			:nth-child(16) {
				-ms-grid-row: 16;
			}
			:nth-child(17) {
				-ms-grid-row: 17;
			}
			:nth-child(18) {
				-ms-grid-row: 18;
			}
			:nth-child(19) {
				-ms-grid-row: 19;
			}
			:nth-child(20) {
				-ms-grid-row: 20;
			}
			:nth-child(21) {
				-ms-grid-row: 21;
			}
			:nth-child(22) {
				-ms-grid-row: 23;
			}
			:nth-child(24) {
				-ms-grid-row: 24;
			}
		}

		&.grow {
			// transform: scaleY(0);
			transform-origin: bottom left;
			transition: transform 0s ease 0s;
		}

	}
	.traffic-map__tick {
		position: relative;

		&:first-child {

			&::before {
				content: '';
				position: absolute;
				top: 0;
				right: -1px;
				width: 8px;
				border-bottom: 1px solid rgba($grey, .35);;
			}

			span {
				top: -7px;
				bottom: auto;

				@include mq(tab) {
					top: -9px;
				}
			}

		}

		&:nth-child(even) {

			&::after {
				content: '';
				position: absolute;
				bottom: 0;
				right: -1px;
				width: 8px;
				border-bottom: 1px solid rgba($grey, .35);
			}

		}

		span {

			// font-family: $open;
			font-size: .5rem;
			text-transform: uppercase;
			color: $grey;
			letter-spacing: .1em;
			display: block;
			position: absolute;
			bottom: -6px;
			left: 0;
			right: 1rem;
			text-align: center;

			@include mq(tab) {
				bottom: -9px;
				font-size: .8rem;
			}
		}
	}
	.traffic-map__cell {
		background-color: $blue;
		color: $white;
		// font-family: $open;
		font-size: 0;
		position: relative;
		z-index: 1;

		transition: transform 0s ease, opacity 0s ease;

		span { opacity: 0; }

	}

	.traffic-map__legend {
		max-width: 14rem;
		margin: 2.5rem auto 0;
	}

	.traffic-map__legend-gradient {
		height: 1rem;
		margin-bottom: .75rem;
		/* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#23a1c0+0,23a1c0+100&0+0,1+100 */
		background: -moz-linear-gradient(left, rgba(35,161,192,0.05) 0%, rgba(35,161,192,1) 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(left, rgba(35,161,192,0.05) 0%,rgba(35,161,192,1) 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(to right, rgba(35,161,192,0.05) 0%,rgba(35,161,192,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	}

	.traffic-map__legend-text {
		// font-family: $open;
		font-size: .7rem;
		color: $grey;
		letter-spacing: .1em;
		position: relative;
		height: 1rem;

		@include mq(tab) {
			font-size: .8rem;
		}

		> span {
			position: absolute;
			bottom: 0;
			white-space: nowrap;
		}

		.sessions {

			@include mq(tabdown) {
				display: none;
			}

		}

		.left {
			left: 0;

			@include mq(tab) {
				transform: translate3d(-50%, 0, 0);
			}
		}

		.right {
			right: 0;

			@include mq(tab) {
				transform: translate3d(50%, 0, 0);
			}
		}
	}

</style>